import React from "react";
import logo from "./logo.svg";
import "./App.css";
import Wizard from "./components/Wizard";
import src from "./logo.png";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  typography: {
    fontSize: 18,
  },
  palette: {
    text: {
      secondary: "rgba(0, 0, 0, .75)",
    },
  },
});
const App: React.FC = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <div className="content">
        <Wizard />
      </div>
    </MuiThemeProvider>
  );
};

export default App;
